import mainReducer from './modules/main/store/reducer';
import wizardReducer from './modules/wizard/store/wizard.reducer';
import personReducer from './modules/person/person.reducer';
import contactReducer from './modules/contact/contact.reducer';
import analyticsReducer from './modules/analytics/store/analytics.reducer';
import serviceReducer from './modules/service/store/service.reducer';

const initialReducer = {
  main: mainReducer,
  wizard: wizardReducer,
  person: personReducer,
  contact: contactReducer,
  analytics: analyticsReducer,
  service: serviceReducer,
};

export default initialReducer;
